import BetweenPagesMessage from "./betweenPagesMessage";

export default BetweenPagesMessage;